import { isEqual } from "lodash";
import { useState } from "react";

import { OnlyCurrentEmployeesQuickFilter } from "./interfaces";

export const useCurrentEmployeesQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<OnlyCurrentEmployeesQuickFilter>({
    onlyWithCurrentEmployees: {
      onlyCurrentEmployees: true,
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof OnlyCurrentEmployeesQuickFilter,
    value: OnlyCurrentEmployeesQuickFilter["onlyWithCurrentEmployees"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    onlyCurrentEmployeesQuickFilter: quickFilter,
    setOnlyCurrentEmployeesQuickFilter: handleChangeQuickFilter,
  };
};
